import { Button, Modal, ModalActions, ModalCloseButton, ModalContent, ModalHeader, ModalLayout } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractCreatedModal = _ref => {
  let {
    isOpen,
    onAssignUsersClick,
    onCloseClick,
    onNewContractClick,
    onViewContractClick
  } = _ref;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    "data-sentry-element": "Modal",
    "data-sentry-component": "ContractCreatedModal",
    "data-sentry-source-file": "ContractCreatedModal.tsx",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      $width: "auto",
      "data-sentry-element": "ModalLayout",
      "data-sentry-source-file": "ContractCreatedModal.tsx",
      "data-sentry-element": "ModalLayout",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        "data-sentry-element": "ModalHeader",
        "data-sentry-source-file": "ContractCreatedModal.tsx",
        "data-sentry-element": "ModalHeader",
        children: "New contract has been added!"
      }), /*#__PURE__*/_jsx(ModalCloseButton, {
        onClick: onCloseClick,
        "data-sentry-element": "ModalCloseButton",
        "data-sentry-source-file": "ContractCreatedModal.tsx",
        "data-sentry-element": "ModalCloseButton"
      }), /*#__PURE__*/_jsx(ModalContent, {
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "ContractCreatedModal.tsx",
        "data-sentry-element": "ModalContent",
        children: "What do you want to do next?"
      }), /*#__PURE__*/_jsxs(ModalActions, {
        "data-sentry-element": "ModalActions",
        "data-sentry-source-file": "ContractCreatedModal.tsx",
        "data-sentry-element": "ModalActions",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onNewContractClick,
          type: "button",
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ContractCreatedModal.tsx",
          "data-sentry-element": "Button",
          children: "Create another"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onAssignUsersClick,
          type: "button",
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ContractCreatedModal.tsx",
          "data-sentry-element": "Button",
          children: "Assign users"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onViewContractClick,
          type: "button",
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ContractCreatedModal.tsx",
          "data-sentry-element": "Button",
          children: "View contract"
        })]
      })]
    })
  });
};